import * as React from "react";
const Illustator = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 240 234"
    style={{
      enableBackground: "new 0 0 240 234",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {"\n\t.st0{fill:#330000;}\n\t.st1{fill:#FF9A00;}\n"}
    </style>
    <g id="Layer_2_1_">
      <g id="Surfaces">
        <g id="Drawing_Surface">
          <g id="Outline_no_shadow">
            <path
              className="st0"
              d="M42.5,0h155C221,0,240,19,240,42.5v149c0,23.5-19,42.5-42.5,42.5h-155C19,234,0,215,0,191.5v-149      C0,19,19,0,42.5,0z"
            />
          </g>
        </g>
      </g>
      <g id="Outlined_Mnemonics_Logos">
        <g id="Ai">
          <path
            className="st1"
            d="M116.3,140.4H79.1l-7.6,23.5c-0.2,0.9-1,1.5-1.9,1.4H50.8c-1.1,0-1.4-0.6-1.1-1.8l32.2-92.7     c0.3-1,0.6-2.1,1-3.3c0.4-2.1,0.6-4.3,0.6-6.5c-0.1-0.5,0.3-1,0.8-1.1c0.1,0,0.2,0,0.3,0h25.6c0.8,0,1.2,0.3,1.3,0.8l36.5,103     c0.3,1.1,0,1.6-1,1.6h-20.9c-0.7,0.1-1.4-0.4-1.6-1.1L116.3,140.4z M84.9,120.1h25.4c-0.6-2.1-1.4-4.6-2.3-7.2     c-0.9-2.7-1.8-5.6-2.7-8.6c-1-3.1-1.9-6.1-2.9-9.2c-1-3.1-1.9-6-2.7-8.9c-0.8-2.8-1.5-5.4-2.2-7.8h-0.2c-0.9,4.3-2,8.6-3.4,12.9     c-1.5,4.8-3,9.8-4.6,14.8C87.9,111.2,86.4,115.9,84.9,120.1L84.9,120.1z"
          />
          <path
            className="st1"
            d="M169.8,77c-3.3,0.1-6.5-1.2-8.9-3.5c-2.3-2.5-3.5-5.8-3.4-9.2c-0.1-3.4,1.2-6.6,3.6-8.9     c2.4-2.3,5.6-3.5,8.9-3.5c3.9,0,6.9,1.2,9.1,3.5c2.2,2.4,3.4,5.6,3.3,8.9c0.1,3.4-1.1,6.7-3.5,9.2     C176.6,75.9,173.2,77.2,169.8,77z M158.6,163.8v-77c0-1,0.4-1.4,1.3-1.4h19.8c0.9,0,1.3,0.5,1.3,1.4v77c0,1.1-0.4,1.6-1.3,1.6     h-19.6C159.1,165.4,158.6,164.8,158.6,163.8z"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default Illustator;
